// extracted by mini-css-extract-plugin
export default {"zoomModal":"e2-z"};